import * as Yup from 'yup';

function schema() {
  return Yup.object().shape({
    id: Yup.string().required('Id is required'),
    acceptSms: Yup.boolean(),
    acceptMarketing: Yup.boolean(),
    acceptSmsAt: Yup.string().nullable(true),
    acceptMarketingAt: Yup.string().nullable(true),
  });
}

export default schema;
